module.exports = __webpack_public_path__ + "static/media/logo_sv.2954bc1b.svg";